module.exports = __webpack_public_path__ + "static/insta-social-media-logos-set-d170b0aabf95b122f2fc36aa70c8df3b.png";